import * as React from 'react';

export const Vin = () => (
	<svg
		style={{
			position: 'absolute',
			top: 0,
			left: 0,
			width: '100%',
			height: '100%',
			pointerEvents: 'none',
		}}
		viewBox="0 0 274 554"
		preserveAspectRatio="xMidYMid meet"
		overflow="visible"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			fill="rgba(0,0,0,0.7)"
			d="M-99999 -99999 H99999 V99999 H-99999 Z M50 60H225V494H50Z"
		/>
	</svg>
);
